import { inject, Injectable } from '@angular/core';
import {
  LoggedInDetails,
  SessionTimeOutModelContent,
  SignupLoginContent,
  ToolTipToggle
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AdobeDataLayerService,
  ANALYTICS_EVENTS,
  ClickEventAnalytics,
  CookieHelperService,
  MFA_BOOKING_CONFIRMATION_TOOLTIP
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { LoginFacadeService } from '../../../data-access/facades/login/login-facade.service';

@Injectable({
  providedIn: 'root'
})
export class LoginWrapperHelperComponent {
  emptySignupLoginContent: SignupLoginContent = {} as SignupLoginContent;
  emptyLoggedInDetails: LoggedInDetails = {} as LoggedInDetails;
  emptyToolTipToggles: ToolTipToggle = {} as ToolTipToggle;
  emptySessionTimeout: SessionTimeOutModelContent =
    {} as SessionTimeOutModelContent;

  isMobileAndTabletDevice$ = new BehaviorSubject<boolean>(false);
  flyoutToggle$ = new BehaviorSubject<boolean>(false);
  loginFacadeService = inject(LoginFacadeService);
  cookieHelper = inject(CookieHelperService);
  private adobeDataLayer = inject(AdobeDataLayerService);

  closeSignUpTooltip(): void {
    this.cookieHelper.setCookieName('hideSignUpTooltip', true, 365, false, '');
    this.loginFacadeService.updateToolTipToggle({
      displaySignUpToolTip: false
    });
  }

  closeLoginTooltip(): void {
    this.cookieHelper.setCookieName('hideLoginTooltip', true, 365, false, '');
    this.loginFacadeService.updateToolTipToggle({
      displayLoginToolTip: false
    });
  }

  closeAccountRecoveryTooltip(): void {
    this.cookieHelper.setCookieName(
      `hideAccountRecoveryTooltip_${this.loginFacadeService.tooltipUserIdentifier}`,
      true,
      365,
      false,
      ''
    );
    this.loginFacadeService.updateToolTipToggle({
      displayAccountRecoveryToolTip: false
    });
    this.trackAccountRecoveryTooltipAnalytics(
      MFA_BOOKING_CONFIRMATION_TOOLTIP.CLOSE.CLICK_NAME,
      MFA_BOOKING_CONFIRMATION_TOOLTIP.CLOSE.ACTION
    );
  }

  trackAccountRecoveryAddRecovery(): void {
    this.trackAccountRecoveryTooltipAnalytics(
      MFA_BOOKING_CONFIRMATION_TOOLTIP.ADD_RECOVERY.CLICK_NAME,
      MFA_BOOKING_CONFIRMATION_TOOLTIP.ADD_RECOVERY.ACTION
    );
  }

  private trackAccountRecoveryTooltipAnalytics(
    clickName: string,
    action: string
  ): void {
    const analyticsData: ClickEventAnalytics = {
      event_detail: MFA_BOOKING_CONFIRMATION_TOOLTIP.EVENT_DETAIL,
      event: ANALYTICS_EVENTS.CLICK,
      user: {
        attributes: {
          is_logged_in: '',
          login_state: ''
        }
      },
      click: {
        name: clickName,
        type: MFA_BOOKING_CONFIRMATION_TOOLTIP.CLICK_TYPE,
        page_section: MFA_BOOKING_CONFIRMATION_TOOLTIP.PAGE_SECTION,
        action
      }
    };
    this.adobeDataLayer.setUserDataInAnalytics(analyticsData);
  }
}
